import { useBucket } from '@mc/experiments-react'
import { trackExperimentViewed } from '@mc/track-event'

import { OUTCOME_PAGES_EXP_KEY } from './constants'

export const trackOutcomePagesExperimentViewed = () => {
  trackExperimentViewed(OUTCOME_PAGES_EXP_KEY)
}

export const useOutcomePagesBucket = () => {
  const bucket = useBucket(OUTCOME_PAGES_EXP_KEY)
  const isVariant = !!bucket?.startsWith('variant')

  return {
    bucket,
    isVariant,
  }
}
